import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row justify-content-center mb-3 mt-3 date-navigator" }
const _hoisted_2 = { class: "row w-100 text-center mt-3 mb-3" }
const _hoisted_3 = { class: "col hidden-calendar-monthly" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1)
const _hoisted_5 = { class: "col text-center hidden-calendar-monthly" }
const _hoisted_6 = { class: "date-header" }
const _hoisted_7 = { class: "col hidden-calendar-monthly" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1)
const _hoisted_9 = { class: "row w-100 text-center parkops-list" }
const _hoisted_10 = { class: "mt-3" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { key: 4 }
const _hoisted_16 = {
  key: 0,
  class: "row w-100 text-center opsinfo-list mt-3"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "col-sm-6" }
const _hoisted_19 = {
  key: 0,
  class: "col-sm-6"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "All Day", -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  class: "col-sm-6"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = {
  key: 2,
  class: "col-sm-6"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 0,
  class: "updating col-sm-12 text-center hidden-calendar-monthly mt-5 mb-3"
}
const _hoisted_29 = ["href"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ticket-alt mr-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: _ctx.prevDayUrl,
          replace: "",
          class: _normalizeClass(["btn", { disabled: !_ctx.canMovePrevDay }])
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["to", "class"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.activityDateFullName), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: _ctx.nextDayUrl,
          replace: "",
          class: _normalizeClass(["btn", { disabled: !_ctx.canMoveNextDay }])
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["to", "class"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dayOperatingHours, (opSchedule) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col text-center",
          key: opSchedule.extCalendarId
        }, [
          _createElementVNode("h6", _hoisted_10, _toDisplayString(_ctx.resolvePark(opSchedule.extCalendarId).displayName), 1),
          (opSchedule.isClosed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.resolvePark(opSchedule.extCalendarId).closedText), 1))
            : (opSchedule.closedToPublic)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.resolvePark(opSchedule.extCalendarId).closedToPublicText), 1))
              : (opSchedule.isAllDay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.resolvePark(opSchedule.extCalendarId).allDayText), 1))
                : (opSchedule.isTbd)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.resolvePark(opSchedule.extCalendarId).tbdText), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(opSchedule.from) + " — " + _toDisplayString(opSchedule.to), 1))
        ]))
      }), 128))
    ]),
    (_ctx.infoHoursMap.hasInfoSchedules)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoHoursMap.parks, (park) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col text-center",
              key: park.extCalendarId
            }, [
              (park.infoHoursHeadline)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_17, _toDisplayString(park.infoHoursHeadline), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(park.infoSchedules, (infoSchedule) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row",
                  key: infoSchedule.extCalendarId
                }, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(infoSchedule.content.displayName), 1),
                  (infoSchedule.hours.isAllDay)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                    : (infoSchedule.hours.from)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          (infoSchedule.hours.prependText)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(infoSchedule.hours.prependText), 1))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(infoSchedule.hours.from) + " ", 1),
                          (infoSchedule.hours.to)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, "— " + _toDisplayString(infoSchedule.hours.to), 1))
                            : _createCommentVNode("", true),
                          _createTextVNode(),
                          (infoSchedule.hours.appendText)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(infoSchedule.hours.appendText), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (infoSchedule.content.opsInfoClosedText)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(infoSchedule.content.opsInfoClosedText), 1))
                        : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.dayOperatingHours[0].isClosed && !_ctx.dayOperatingHours[0].isTbd)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          (_ctx.purchaseCTAName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("a", { href: _ctx.purchaseCTAName }, [
                  _hoisted_30,
                  _createTextVNode(_toDisplayString(_ctx.purchaseCTAUrl), 1)
                ], 8, _hoisted_29)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}